const InputErrors = {
  email: "sender_email",
  searchPartnersEmails: "search_partners_emails",
  name: "sender_name",
  phone: "sender_phone",
  question: "question_required"
};

const hasGenericErrors = errors =>
  errors.some(error => error.type === "message_not_sent");

const inputErrorFor = (formErrors, inputName) => {
  const formError = formErrors.find(
    error => error.type === InputErrors[inputName]
  );
  if (formError) {
    return formError.messages[0];
  }
  return null;
};

export { hasGenericErrors, inputErrorFor };
